import { adminHttpClient } from '../../../commons/adminHttpClient'
import localStorage from '../../../commons/localStorage'
import { Plan } from '../state'

export type Question5Values = Omit<
  Plan,
  | 'planMetalTiersOptions'
  | 'deductibleOptions'
  | 'maxOutOfPocketOptions'
  | 'budgetGoal'
  | 'budgetGoalsOptions'
  | 'employeeContributionStrategyOptions'
  | 'availableReimbursementOptions'
  | 'employeeCategoryOptions'
>

const question5Api = (values: Question5Values): Promise<any> => {
  const code = localStorage.getProspectSignupCode()

  return adminHttpClient.put('/IchraDecisionTool/ProspectApplication/Step2/Question5', {
    token: code,
    plans: [values],
  })
}

export default question5Api
